import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Tooltip,
  InputAdornment,
} from "@material-ui/core";

import { MuiThemeProvider } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { Toolbar, AppBar } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

import axios from "axios";
import { toast } from "react-toastify";
import Notification from "../components/Notification";
import useStyles from "../themes/style";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";

import "../css/agreement-resume.css";
import "../css/candidate_offer_page.css";
import { getMuiTheme } from "./style";
import { MdMessage } from "react-icons/md";
import Cookies from "js-cookie";

const positions = [toast.POSITION.TOP_RIGHT];

function OfferConfirmationByCandidate() {
  const token = localStorage.getItem("token");
  //   const decode = jwtDecode(token);
  const history = useHistory();
  const { candidateId, userId } = useParams();
  const location = useLocation();

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const validationSchema = Yup.object().shape({
    reason: Yup.string().required("Message is required"),
    status: Yup.string().required("Status is required"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      status: "CLARIFICATION",
    },
  });

  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  const theme = useTheme();
  const classes = useStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down("sm"));

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const [loader, setLoader] = useState(false);

  async function handleMakeDesicion(status) {
    if (!candidateId || !userId) {
      handleNotificationCall("success", "Invalid Link");
      return;
    }

    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}auth/changeOfferDetailStatus`,
        {
          id: candidateId,
          userId: userId,
          isAccepted: status,
          discuss_message: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        if (status==="ACCEPTED") {
          Cookies.set(`offer_accept_${candidateId}`, "true", {
            expires: 20,
            path: `/`,
          });
          window.location.reload();
        }
        // localStorage.setItem("offerDetailStatus", status);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  async function sendDiscussionMessage(values) {
    if (!candidateId || !userId) {
      handleNotificationCall("success", "Invalid Link");
      return;
    }
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}auth/changeOfferDetailStatus`,
        {
          id: candidateId,
          userId: userId,
          isAccepted: values.status,
          discuss_message: values.reason,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        // localStorage.setItem("offerDetailStatus", values.status);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    const candidateCookie = Cookies.get(`offer_accept_${candidateId}`);
    if (candidateCookie) {
      history.push(`/candidate-self-profile/${candidateId}/${userId}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.backgroundColor}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <>
          <AppBar className={classes.appBarBg}>
            <Toolbar className={classes.toolbarLP}>
              {isMatch ? (
                <>
                  <div className={classes.refoTitleMobile}>
                    <p className="refo-name">refo</p>
                  </div>
                  <div className={classes.flexCenter} style={{ width: "100%" }}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </div>
                  {/* <DrawerComp /> */}
                </>
              ) : (
                <Grid className={classes.gridCenter} container spacing={2}>
                  <Grid item xs={1} md={1} className={classes.refoTitle}>
                    <p className="refo-name">refo</p>
                  </Grid>
                  <Grid item xs={11} md={11} className={classes.flexCenter}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </Grid>
                </Grid>
              )}
            </Toolbar>
          </AppBar>

          <div style={{ marginTop: "5rem", overflow: "auto", height: "90vh" }}>
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                paddingBlock: "3rem",
              }}
            >
              <div className="card">
                <div className="details-form-header">
                  <span className="icon">
                    <svg
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        clipRule="evenodd"
                        d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z"
                        fillRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                  <p className="alert">Job Offer Decision:</p>
                </div>

                <p className="message">
                  We've shared the offer letter including a detailed salary
                  breakdown. Please let us know your decision at your earliest
                  convenience.
                </p>

                <div className="actions">
                  <button
                    className="read"
                    type="button"
                    onClick={() => {
                      handleMakeDesicion("ACCEPTED");
                    }}
                  >
                    Accept
                    {/* Congratulations! We're excited to have you join our team. You'll receive a formal offer letter shortly. */}
                  </button>
                  <button
                    className="mark-as-read"
                    type="button"
                    onClick={handleModalOpen}
                  >
                    Need More Clarification
                    {/* Thank you for your interest in the position. To better assist you, please clarify your concerns regarding [specific concern]. We're happy to provide additional details. */}
                  </button>

                  <button
                    className="mark-as-reject"
                    type="button"
                    onClick={() => {
                      handleMakeDesicion("DECLINED");
                    }}
                  >
                    Decline
                    {/* We're disappointed to hear that you've decided not to accept our offer. We wish you all the best in your job search. */}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Dialog
            aria-labelledby="dialog-title"
            open={modalOpen}
            width="xs"
            maxWidth="xs"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <form onSubmit={handleSubmit(sendDiscussionMessage)}>
              <h2
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 500,
                  padding: "10px 20px",
                  margin: "0px",
                  display: "flex",
                  gap: "6px",
                  alignItems: "center",
                }}
              >
                <MdMessage color="#074799" size={25} />
                <span>Write a Message</span>
              </h2>
              <DialogContent dividers>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Grid>
                    <TextField
                      type="text"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      size="small"
                      style={{ display: "none" }}
                      value="CLARIFICATION"
                      {...register("status")}
                    />
                    <InputLabel shrink htmlFor="reason">
                      Message
                    </InputLabel>

                    <FormControl className={classes.margin}>
                      <TextField
                        multiline
                        rows={6}
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        size="small"
                        placeholder="Write a message"
                        id="reason"
                        {...register("reason")}
                        error={errors.reason ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.reason?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  <Grid style={{ display: "flex", gap: "10px" }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={handleModalClose}
                      style={{ flex: 1 }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                      style={{ flex: 1 }}
                    >
                      Send
                    </Button>
                  </Grid>
                </div>
              </DialogContent>
            </form>
          </Dialog>

          <ToastContainer
            closeButton={
              <CloseButton className={classes.notificationCloseButton} />
            }
            closeOnClick={false}
            hideProgressBar={true}
          />
          <Backdrop className={classes.backdrop} open={loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      </MuiThemeProvider>
    </div>
  );
}

export default OfferConfirmationByCandidate;
function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
